(function () {
  if (!customElements.get('mobile-plp-bar')) {
    customElements.define(
      'mobile-plp-bar',
      class MobilePLPBar extends HTMLElement {
        constructor() {
          super();
          this.offset = this.dataset.offset;
          this.handleScroll = this.handleScroll.bind(this);
          this.throttledScroll = throttle(this.handleScroll, 100);
        }

        handleScroll() {
          if (window.innerWidth >= 750) return;
          const barTop = this.offsetTop;
          const scrollY = window.scrollY;
          if (scrollY > barTop - this.offset && scrollY > this.offset) {
            this.classList.add('fixed');
          } else {
            this.classList.remove('fixed');
          }
        }

        connectedCallback() {
          window.addEventListener('scroll', this.throttledScroll, {
            passive: true,
          });
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.throttledScroll);
        }
      }
    );
  }
})();
